import BaseMenu from '../Menu/BaseMenu';
import { WheelQuitConfirmLayout } from "Layouts/Wheel/WheelQuitConfirmLayout";
import BaseUISystem from '../BaseUISystem';
import { PopupID } from "State/UI/PopupID";
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { GameObjectEvent } from "GameObject/GameObject";
import { UIActions } from "State/UI/UIActions";
import { applyDefaultButtonAnimation } from '../UIHelper';

type WheelQuitConfirmPopupProps = {};

export class WheelQuitConfirmPopup extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.WHEEL_QUIT_CONFIRM, uiSystem, false);
    }

    public onShow(props: WheelQuitConfirmPopupProps): void {
        super.onShow(props);

        this.layout = new WheelQuitConfirmLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        this.layout.closeButton.on(GameObjectEvent.SELECTED, this.handleCloseClick);
        this.layout.leaveButton.on(GameObjectEvent.SELECTED, this.handleLeaveClick);
        this.layout.stayButton.on(GameObjectEvent.SELECTED, this.handleStayClick);

        this.cleanupManager.add(() => {
            this.layout.closeButton.off(GameObjectEvent.SELECTED, this.handleCloseClick);
            this.layout.leaveButton.off(GameObjectEvent.SELECTED, this.handleLeaveClick);
            this.layout.stayButton.off(GameObjectEvent.SELECTED, this.handleStayClick);
        });

        [
            this.layout.closeButton,
            this.layout.leaveButton,
            this.layout.stayButton,
        ].forEach((button) => {
            applyDefaultButtonAnimation(button);
        });
    }

    private readonly handleCloseClick = (): void => {
        UIActions.hidePopup(PopupID.WHEEL_QUIT_CONFIRM);
    };

    private readonly handleLeaveClick = (): void => {
        UIActions.hidePopup(PopupID.WHEEL_QUIT_CONFIRM);
    };

    private readonly handleStayClick = (): void => {
        UIActions.queuePopup(PopupID.WHEEL, { premium: true });
        UIActions.hidePopup(PopupID.WHEEL_QUIT_CONFIRM);
    };
}
